import {
  COGNITO_LOGIN_CALLBACK_ROUTE,
  COGNITO_LOGOUT_CALLBACK_ROUTE
} from '@daedalus/core/src/auth/constants'

export const HOME_ROUTE = '/'
export const SEARCH_ROUTE = '/Hotel/Search'
export const PROVIDER_REDIRECT_ROUTE = '/ProviderRedirect'
export const PROFILE_ROUTE = '/Profile'
export const ALERTS_ROUTE = '/user/alerts'
export const MEMBERSHIP_ROUTE = '/user/membership'
export const ACCOUNT_ROUTE = '/user/account'
export const REFERRAL_ROUTE = '/user/membership/referral'

export const ACCOMMODATION_ROUTE = '/Hotel/[hotelSlug]'

export const VIO_OFFER_CLICKED = 'vio_offer_clicked'

/**
 * Paths migrated to Next.js Pages router.
 */
export const MIGRATED_ROUTER_PATHS: string[] = [
  PROVIDER_REDIRECT_ROUTE,
  HOME_ROUTE,
  COGNITO_LOGIN_CALLBACK_ROUTE,
  COGNITO_LOGOUT_CALLBACK_ROUTE,
  '/*debugPanel',
  PROFILE_ROUTE,
  ALERTS_ROUTE,
  MEMBERSHIP_ROUTE,
  ACCOUNT_ROUTE,
  REFERRAL_ROUTE,
  SEARCH_ROUTE,
  ACCOMMODATION_ROUTE
]
